module.exports = __webpack_public_path__ + "img/planet.250b65d6.webp";